import { StrictMode, useCallback, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import Auth from './pages/Auth';
import { StoreProvider } from './state/store';
import { loadSession, logout, type Session } from './state/api';
import './styles.css';

function Root() {
  const [session, setSession] = useState<Session | null>(() => loadSession());

  const onAuthed = useCallback(() => {
    setSession(loadSession());
  }, []);

  const onLogout = useCallback(() => {
    logout();
    setSession(null);
  }, []);

  useEffect(() => {
    const onSession = (event: Event) => {
      const detail = (event as CustomEvent<Session>).detail;
      setSession(detail ?? loadSession());
    };
    window.addEventListener('anchor:session', onSession);
    return () => window.removeEventListener('anchor:session', onSession);
  }, []);

  if (!session) {
    return <Auth onAuthed={onAuthed} />;
  }

  return (
    <StoreProvider key={session.orgId}>
      <App onLogout={onLogout} session={session} />
    </StoreProvider>
  );
}

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root not found');

createRoot(root).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
